<template>
  <div>
    <div class="majorTitle textLeft">
      Favorites
    </div>
    <!-- Show selected favorite type -->
    <div v-if="type === 'items'">
      <FavoriteItems :list-id="listId" />
    </div>
    <!-- Show list of favorite types (in the future we may want to favorite stories or other things) -->
    <div v-else>
      <!-- TODO: style this list of favorite types -->
      <div @click="onTypeClick('items')">
        Items
      </div>
    </div>
  </div>
</template>

<script>
import FavoriteItems from '@/components/Favorites/FavoriteItems'

/**
 * The Container component for Favorites list in AccountCard.
 * @displayName Favorites Container Component
 */
export default {
	name: 'FavoritesContainer',
	components: {
		FavoriteItems
	},
	props: [],
	data () {
		return {
			type: 'items'
		}
	},
	computed: {
		/**
		 * The customer (me)
		 *
		 * @public
		 */
		customer: function () {
			return this.$store.state.customer
		},
		/**
		 * Customer favorites list id
		 *
		 * @public
		 */
		listId: function () {
			if (typeof (this.customer.favorite_list_id) !== 'undefined') {
				return this.customer.favorite_list_id
			}
		}
	},
	watch: {
		/**
		 * Gets called when the customer changes.
		 *
		 * @public
		 */
		listId: function (current, previous) {
			if (current) {
				// Dispatch the get favorites action
				this.$store.dispatch('getFavorites', { page: 1 })
			}
		}
	},
	/**
		* Gets called when this component has mounted.
		*
		* @public
		*/
	mounted () {},
	methods: {
		/**
		 * Gets called when user selects a favorite type to view.
		 * (Currently, only inventory items can be favorited)
		 *
		 * @public
		 */
		onTypeClick (type) {
			this.type = type
		}
	}
}
</script>

<style scoped></style>
